/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../../tslib.es6-e01eabb2.js';

// API: https://open.dingtalk.com/document/orgapp-client/obtain-current-geographic-location-information-single-positioning?spm=ding_open_doc.document.0.0.c97f4399SeHacV#topic-2025194
function getLocation(options, context) {
    var _a;
    var api = 'dd.device.geolocation.get'; // 该api需要钉钉鉴权：https://open.dingtalk.com/document/orgapp-client/jsapi-overview
    var formatInput = function (input) {
        var _a;
        var dingTalk = ((_a = input === null || input === void 0 ? void 0 : input._ext) !== null && _a !== void 0 ? _a : {}).dingTalk;
        return __assign({ targetAccuracy: 200, coordinate: 0, withReGeocode: false, useCache: true }, dingTalk);
    };
    var formatOutput = function (ret) { return ({
        longitude: ret.longitude.toString(),
        latitude: ret.latitude.toString(),
    }); };
    (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: formatInput, formatOutput: formatOutput });
}

export { getLocation as default };
